export const scoreClusterLabelsValues = ['poor', 'bad', 'moderate', 'good', 'high'] as const;

// Step 2: Create a type from the array
export type ScoreClusterLabels = (typeof scoreClusterLabelsValues)[number];

export const scoreClusterLabelsValuesCapitalized = ['Poor', 'Bad', 'Moderate', 'Good', 'High'] as const;

// Step 2: Create a type from the array
export type ScoreClusterLabelsCapitalized = (typeof scoreClusterLabelsValuesCapitalized)[number];
